module.exports = __webpack_public_path__ + "img/weichat.ce404641.png";